<template>
  <el-pagination class="pagination" layout="total, prev, pager, next" @size-change="handleSizeChange"
    @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currPage" :total="total"></el-pagination>
</template>
<script>
export default {
  props: {
    handleSizeChange: {
      typeof: Function, // 切换当页条数
    },
    handleCurrentChange: {
      typeof: Function, // 切换页码
    },
    currPage: {
      typeof: String, // 当前页码
    },
    pageSize: {
      typeof: String, // 当页条数
    },
    total: {
      typeof: Number, // 总条数
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less">
.pagination {
  text-align: center;

  .el-pager li,
  button {
    margin: 0 10px;
    width: 40px;
    height: 40px !important;
    font-weight: 400;
    font-size: 20px;
    font-family: ArialMT;
    color: #000000;
    line-height: 40px !important;
  }

  .el-pager li,
  .btn-prev,
  .btn-next,
  button:disabled {
    background: inherit;
  }

  .el-pager li.active {
    color: #ffffff !important;
    cursor: default;
    background: #005fe1 !important;
  }

  .el-pagination__total {
    margin-right: 40px;
    font-size: 14px !important;
    font-family: MicrosoftYaHei !important;
    color: #000000 !important;
    line-height: 36px !important;
  }
}
</style>
